import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { isEmpty } from 'src/app/shared/utilities/obj-utilities';
import { ProfessionSpecialtyModel } from '../models/specialty.model';
import { MarginCalculatorBaseService } from './margin-calculator-base.service';

@Injectable({
    providedIn: 'root'
})
export class MarginCalculatorSpecialtyService extends MarginCalculatorBaseService {
    constructor(private readonly _http: HttpClient) {
        super();
    }

    getSpecialty(professionId: number, expertiseId: number): Observable<ProfessionSpecialtyModel> {
        if (isEmpty(professionId) || isEmpty(expertiseId)) {
            return null;
        }

        const path = `${this.coreApiPath}/margin-calculator/specialty?professionId=${professionId}&expertiseId=${expertiseId}`;
        return this._http.get<ProfessionSpecialtyModel>(path);
    }
}
